export type Lang = "ro" | "en";

const ro = {
    // Quote
    quote: "Dragostea nu este să te uiți unul la altul, ci să priviți împreună în aceeași direcție.",
    quoteAuthor: "— Antoine de Saint-Exupéry",

    // Welcome page
    enterCode: "Te rog să introduci codul de pe spatele invitației:",
    codePlaceholder: "Codul invitației",
    submit: "Gata!",
    errorBadCode: "Codul nu este bun",
    errorWrongCode: "Codul nu este valid",

    // Coming question
    gladYouCome: (name: string, plural: boolean) =>
        `Ne-am bucura, ${name}, dacă ${plural ? "ați putea" : "ai putea"} veni la nunta noastră.`,
    willBePresent: (plural: boolean) => plural ? "Vom fi prezenți" : "Voi fi prezent",
    cantCome: (plural: boolean) => plural ? "Din păcate, nu ajungem" : "Din păcate, nu ajung",
    rsvpDeadline: "Dorim să știm până în data de 1 Septembrie 2026.",

    // Details page
    happyYouCome: (name: string, plural: boolean) =>
        `Ne bucurăm foarte mult, ${name}, că ${plural ? "puteți veni" : "poți veni"}.`,
    optionalEventLabel: "Ceremonia Religioasă",
    optionalEventDetails: "Catedrala Adormirea Maicii Domnului, Str Vasile Lucaciu 59, Baia Mare · Ora 16:00",
    optionalEventNote: "(opțional, poate veni cine vrea)",
    optionalEventMapLink: "https://maps.app.goo.gl/6BodBMfWpMZeoobg7",
    eventDate: "26 Septembrie 2026",
    venueLabel: "Recepție",
    venueDetails: "Melody, Strada Principală 1, 447230 Păulești, Satu Mare · Ora 20:00",
    venueMapLink: "https://maps.app.goo.gl/BqgPnkTpiBiBXf5h6",
    directions: "Direcții",
    addToCalendar: "Adaugă evenimentul în calendar:",
    numberOfPersons: "Număr de persoane (meniuri):",
    needHotel: "Este nevoie de cazare?",
    comingWithKids: (plural: boolean) => `O să ${plural ? "vi" : "veniți"} cu copii?`,
    numberOfKids: "Număr de copii:",
    numberOfKidsMenus: "Număr de meniuri de copii (jumătate din meniul normal):",
    vegetarianMenus: "Este nevoie de meniuri vegetariene?",
    numberOfVegetarianMenus: "Număr de meniuri vegetariene:",
    contactUs: "Pentru mai multe informații, ne puteți contacta la:",
    notComingQuestion: (plural: boolean) =>
        `În caz că nu mai ${plural ? "puteți veni" : "poți veni"}, vă rugăm să apăsați aici:`,
    saveSuccess: "Modificările au fost salvate cu succes.",
    saveError: "Ceva nu a mers bine. Te rog să dai refresh la pagină.",
    yes: "Da",
    no: "Nu",

    // Phone numbers
    alecs_ro: "0746412993",
    alecs_uk: "+44 7572115080",
    oana_ro: "0744187210",

    // Parents
    parent1: "Dan Vitoc",
    parent1_phone: "0745610085",
    parent2: "Liliana Vitoc",
    parent2_phone: "0746189267",
    parent3: "Radu Sabadâș",
    parent3_phone: "0740084333",
    parent4: "Simona Sabadâș",
    parent4_phone: "0740037669",

    // Godfathers
    godfathersLabel: "Nași:",
    godfather1: "Andrei Oros",
    godfather2: "Bianca Oros",

    // Refused page
    sorryNotComing: (plural: boolean) =>
        `Ne pare rău că nu ${plural ? "puteți veni" : "poți veni"}.`,
    changedMind: (plural: boolean) =>
        `În caz că ${plural ? "v-ați răzgândit" : "te-ai răzgândit"}, te rog să apeși pe butonul de mai jos:`,
    willCome: (plural: boolean) => plural ? "O să fim prezenți" : "O să fiu prezent",

    // Classic invite
    godBlessing: "Cu binecuvântarea Lui Dumnezeu,",
    alongsideParents: "Alături de părinții noștri,",
    alongsideGodfathers: "și de nașii noștri,",
    inviteText: "Vă invităm să ne fiți alături la celebrarea căsătoriei noastre,",
    weddingDate: "26 Septembrie 2026",
    religiousCeremony: "Ceremonia Religioasă",
    religiousVenue: "Catedrala Adormirea Maicii Domnului, Baia Mare",
    religiousTime: "Ora 16:00",
    reception: "Recepție",
    receptionVenue: "Melody, Păulești",
    receptionTime: "Ora 20:00",
    weWaitForYou: "Vă așteptăm cu drag!",
    confirmAttendance: "Apasă aici pentru a confirma/infirma prezența",
    pleaseConfirm: "Vă rugăm să ne confirmați prezența până în data de 1 Septembrie 2026:",
};

const en = {
    // Quote
    quote: "Love is not looking at one another, but looking together in the same direction.",
    quoteAuthor: "— Antoine de Saint-Exupéry",

    // Welcome page
    enterCode: "Please enter the code from the back of your invitation:",
    codePlaceholder: "Invitation code",
    submit: "Go!",
    errorBadCode: "The code is incorrect",
    errorWrongCode: "The code is not valid",

    // Coming question
    gladYouCome: (name: string, plural: boolean) =>
        `We would love for you to join us at our wedding, ${name}.`,
    willBePresent: (plural: boolean) => plural ? "We will be there" : "I will be there",
    cantCome: (plural: boolean) => plural ? "Unfortunately, we can't make it" : "Unfortunately, I can't make it",
    rsvpDeadline: "Please let us know by September 1st, 2026.",

    // Details page
    happyYouCome: (name: string, plural: boolean) =>
        `We are so happy you can make it, ${name}!`,
    optionalEventLabel: "Religious Ceremony",
    optionalEventDetails: "Cathedral of the Dormition of the Mother of God, Str Vasile Lucaciu 59, Baia Mare · 4:00 PM",
    optionalEventNote: "(optional, anyone can attend if they wish)",
    optionalEventMapLink: "https://maps.app.goo.gl/6BodBMfWpMZeoobg7",
    eventDate: "26 September 2026",
    venueLabel: "Reception",
    venueDetails: "Melody, Strada Principală 1, 447230 Păulești, Satu Mare · 7:00 PM",
    venueMapLink: "https://maps.app.goo.gl/BqgPnkTpiBiBXf5h6",
    directions: "Directions",
    addToCalendar: "Add the event to your calendar:",
    numberOfPersons: "Number of people (meals):",
    needHotel: "Do you need accommodation?",
    comingWithKids: (plural: boolean) => "Will you be bringing kids?",
    numberOfKids: "Number of kids:",
    numberOfKidsMenus: "Number of kids meals (half a normal meal):",
    vegetarianMenus: "Do you need vegetarian meals?",
    numberOfVegetarianMenus: "Number of vegetarian meals:",
    contactUs: "For more information, you can reach us at:",
    notComingQuestion: (plural: boolean) =>
        `If you can no longer attend, please let us know:`,
    saveSuccess: "Your changes have been saved successfully.",
    saveError: "Something went wrong. Please refresh the page.",
    yes: "Yes",
    no: "No",

    // Phone numbers (with +40 prefix for Romanian numbers)
    alecs_ro: "+40 746412993",
    alecs_uk: "+44 7572115080",
    oana_ro: "+40 744187210",

    // Parents
    parent1: "Dan Vitoc",
    parent1_phone: "+40 745610085",
    parent2: "Liliana Vitoc",
    parent2_phone: "+40 746189267",
    parent3: "Radu Sabadâș",
    parent3_phone: "+40 740084333",
    parent4: "Simona Sabadâș",
    parent4_phone: "+40 740037669",

    // Godfathers
    godfathersLabel: "Godfathers:",
    godfather1: "Andrei Oros",
    godfather2: "Bianca Oros",

    // Refused page
    sorryNotComing: (plural: boolean) =>
        `We're sorry you can't make it.`,
    changedMind: (plural: boolean) =>
        `If you've changed your mind, please press the button below:`,
    willCome: (plural: boolean) => plural ? "We will be there" : "I will be there",

    // Classic invite
    godBlessing: "With God's blessing,",
    alongsideParents: "Together with our parents,",
    alongsideGodfathers: "and our godparents,",
    inviteText: "We invite you to join us in the celebration of our marriage,",
    weddingDate: "26 September 2026",
    religiousCeremony: "Religious Ceremony",
    religiousVenue: "Cathedral of the Dormition of the Mother of God, Baia Mare",
    religiousTime: "4:00 PM",
    reception: "Reception",
    receptionVenue: "Melody, Păulești",
    receptionTime: "8:00 PM",
    weWaitForYou: "We look forward to celebrating with you!",
    confirmAttendance: "Click here to confirm or decline your attendance",
    pleaseConfirm: "Please confirm your attendance by September 1st, 2026:",
};

export const translations = { ro, en };
